<template>
  <div>
    <loading v-if="vLoading" />
    <v-row class="justify-content-center">
      <v-col md="8" sm="12">
        <v-card class="mb-4">
          <v-card-title> ویرایش فرم </v-card-title>
          <v-container>
            <v-select
              outlined
              dense
              label="وضعیت"
              v-model="form.status"
              :items="states"
            ></v-select>
          </v-container>
        </v-card>
        <v-card class="mb-4 py-4">
          <v-container>
            <h4 class="text-center text-primary">اطلاعات فردی</h4>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.name"
                  label="نام*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.lastName"
                  label="نام خانوادگی*"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                جنسیت*
                <v-radio-group row v-model="form.gender">
                  <v-radio label="مرد" color="primary" value="male"></v-radio>
                  <v-radio
                    label="زن"
                    color="primary"
                    value="female"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                وضعیت تاهل*
                <v-radio-group row v-model="form.marriage">
                  <v-radio
                    label="مجرد"
                    color="primary"
                    value="single"
                  ></v-radio>
                  <v-radio
                    label="متاهل"
                    color="primary"
                    value="married"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  label="کد ملی*"
                  outlined
                  dense
                  v-model="form.natCode"
                  type="number"
                  :rules="[isID(form.natCode)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.birthCity"
                  label="محل تولد*"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0" cols="12" md="6" lg="6" xl="6">
                  تاریخ تولد:
                  <date-picker ref="datePicker" v-model="form.birthDate" :editable="true" />                        
              </v-col>  
            </v-row>            
            <v-row align="center">
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.age"
                  type="number"
                  label="سن*"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="form.children"
                  label="تعداد فرزندان*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="form.custody"
                  label="تعداد افراد تحت تکفل*"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="form.mobile"
                  label="شماره تلفن همراه*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.phone"
                  label="شماره تلفن ثابت*"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  rows="4"
                  outlined
                  dense
                  v-model="form.address"
                  label="آدرس محل سکونت*"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                نوع محل سکونت*
                <v-radio-group row v-model="form.homeStatus">
                  <v-radio label="مالک" color="primary" value="مالک"></v-radio>
                  <v-radio
                    label="استیجاری"
                    color="primary"
                    value="استیجاری"
                  ></v-radio>
                  <v-radio
                    label="زندگی با خانواده"
                    color="primary"
                    value="زندگی با خانواده"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  label="ایمیل*"
                  v-model="form.email"
                  :rules="[
                    validateEmail(form.email)
                      ? null
                      : 'ایمیل وارد شده صحیح نمی‌باشد',
                  ]"
                  type="email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-4">
          <v-container>
            <h4 class="text-center text-primary">سوابق تحصیلی</h4>
            <v-row>
              <v-col>
                آخرین مقطع تحصیلی*
                <v-radio-group row v-model="form.latestDegree">
                  <v-radio
                    label="دیپلم"
                    color="primary"
                    value="دیپلم"
                  ></v-radio>
                  <v-radio
                    label="کاردانی"
                    color="primary"
                    value="کاردانی"
                  ></v-radio>
                  <v-radio
                    label="کارشناسی"
                    color="primary"
                    value="کارشناسی"
                  ></v-radio>
                  <v-radio
                    label="کارشناسی ارشد"
                    color="primary"
                    value="کارشناسی ارشد"
                  ></v-radio>
                  <v-radio
                    label="دکتری"
                    color="primary"
                    value="دکتری"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                اطلاعات تحصیلی*
                <v-btn
                  style="float: left"
                  class="mb-3"
                  color="primary"
                  outlined
                  @click="addUniInfo()"
                >
                  افزودن +
                </v-btn>
                <b-table
                  responsive
                  show-empty
                  head-variant="light"
                  :fields="educationFields"
                  :items="form.education"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(grade)="data">
                    <v-text-field
                      v-model="data.item.grade"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(start)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.start"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(end)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.end"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(university)="data">
                    <v-text-field
                      v-model="data.item.university"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(major)="data">
                    <v-text-field
                      v-model="data.item.major"
                      outlined
                      dense
                    ></v-text-field>
                  </template>

                  <template v-slot:cell(delete)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <v-btn
                        color="red"
                        outlined
                        @click="deleteUniInfo(data.index)"
                        >حذف</v-btn
                      >
                    </div>
                  </template>
                </b-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-4">
          <v-container>
            <h4 class="text-center text-primary">سوابق کاری</h4>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  label="میزان سابقه کار"
                  type="number"
                  v-model="form.experience"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                اطلاعات سوابق کاری*
                <v-btn
                  style="float: left"
                  class="mb-3"
                  color="primary"
                  outlined
                  @click="addJob()"
                >
                  افزودن +
                </v-btn>
                <b-table
                  responsive
                  show-empty
                  head-variant="light"
                  :fields="jobFields"
                  :items="form.jobs"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(company)="data">
                    <v-text-field
                      v-model="data.item.company"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(position)="data">
                    <v-text-field
                      v-model="data.item.position"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(start)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.start"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(end)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.end"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(salary)="data">
                    <vuetify-money
                      outlined
                      dense
                      v-model="data.item.salary"
                      :valueWhenIsEmpty="whenIsEmpty"
                      :options="moneyOptions"
                      type="number"
                    />
                  </template>
                  <template v-slot:cell(reason)="data">
                    <v-text-field
                      v-model="data.item.reason"
                      outlined
                      dense
                    ></v-text-field>
                  </template>

                  <template v-slot:cell(delete)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <v-btn color="red" outlined @click="deleteJob(data.index)"
                        >حذف</v-btn
                      >
                    </div>
                  </template>
                </b-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card>
          <v-container>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                زمینه همکاری*
                <v-radio-group v-model="form.field">
                  <v-radio
                    v-for="option in jobOpt"
                    :key="option"
                    :label="option"
                    :value="option"
                  >
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <vuetify-money
                  label="حقوق درخواستی(﷼)*"
                  outlined
                  dense
                  v-model="form.salary"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="moneyOptions"
                  type="number"
                />
              </v-col>
            </v-row>
                <v-row v-if="form.date">
                  <v-col>
                    تاریخ ارسال فرم:
                    {{ form.date.split(' ')[0]  }}
                  </v-col>
                </v-row>                   
                <v-row>
                  <v-col>
                    ساعت ارسال فرم:
                    {{ form.date.split(' ')[1]  }}
                  </v-col>
                </v-row>              
            <v-row>
              <v-col>
                <v-textarea
                  class="mt-3"
                  outlined
                  label="یادداشت"
                  v-model="form.notes"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn :loading="isBusy" color="primary" @click="editForm()"
                  >ویرایش</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Axios from "axios";


function checkCodeMeli(code) {
  var L = code.length;

  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
  return true;
}
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      form: {
        education: [
          { start: "", end: "", university: "", major: "", grade: "" },
        ],
        jobs: [
          {
            start: "",
            end: "",
            position: "",
            company: "",
            reason: "",
            salary: "",
          },
        ],
        children: 0,
        custody: 0,
        experience: 0,
      },
      isBusy: false,
      educationFields: [
        { key: "index", label: "#" },
        { key: "grade", label: "مقطع" },
        { key: "start", label: "سال شروع" },
        { key: "end", label: "سال پایان" },
        { key: "university", label: "دانشگاه" },
        { key: "major", label: "رشته" },
        { key: "delete", label: "عملیات" },
      ],
      jobFields: [
        { key: "index", label: "#" },
        { key: "company", label: "نام شرکت" },
        { key: "position", label: "سمت" },
        { key: "start", label: "سال شروع" },
        { key: "end", label: "سال پایان" },
        { key: "salary", label: "حقوق دریافتی(﷼)" },
        { key: "reason", label: " دلیل ترک کار" },
        { key: "delete", label: "عملیات" },
      ],
      jobOpt: [
        "خطوط تولید / تحصیلات مرتبط با ساخت و تولید",
        "خطوط تولید / تحصیلات مرتبط با مکانیک",
        "خطوط تولید / تحصیلات مرتبط با برق",
        "واحد حسابداری / تحصیلات مرتبط با حسابداری",
        "واحد فروش / تحصیلات مرتبط با بازرگانی",
        "مسئول دفتر / تحصیلات حقوق"
      ],
      states: [
        { value: "active", text: "فعال" },
        { value: "deactive", text: "غیرفعال" },
      ],
    };
  },
  methods: {
    isID(id) {
      // NOTE (m-isID) to check the validity of the national code
      return id ? (checkCodeMeli(id) ? null : false) : null;
    },
    validateEmail(email) {
      //NOTE checking validation of email
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      } else return true;
    },
    deleteUniInfo(index) {
      this.form.education.splice(index, 1);
    },
    addUniInfo() {
      this.form.education.push({
        start: "",
        end: "",
        university: "",
        major: "",
        grade: "",
      });
    },
    deleteJob(index) {
      this.form.jobs.splice(index, 1);
    },
    addJob() {
      this.form.jobs.push({
        start: "",
        end: "",
        university: "",
        major: "",
        grade: "",
      });
    },
    showForm() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/form/getInfo",
        {
          formId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.form = res.data;
            this.form.jobs = JSON.parse(this.form.jobs);
            this.form.education = JSON.parse(this.form.education);
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    editForm() {
      this.vLoading = true;
      this.isBusy = true;
      if (
        !this.form.email ||
        !this.form.name ||
        !this.form.lastName ||
        !this.form.gender ||
        !this.form.birthCity ||
        !this.form.birthDate ||
        !this.form.age ||
        !this.form.marriage ||
        !this.form.address ||
        !this.form.homeStatus ||
        !this.form.mobile ||
        !this.form.phone ||
        !this.form.latestDegree ||
        !this.form.experience ||
        !this.form.salary ||
        !this.form.field
      ) {
        this.toast("لطفا تمام فیلدهای فرم را با دقت پر کنید.", "error");
        this.vLoading = false;
        this.isBusy = false;
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/hr/form/edit",
          {
            formId: this.$route.params.id,
            natCode: this.form.natCode,
            status: this.form.status,
            email: this.form.email,
            name: this.form.name,
            lastName: this.form.lastName,
            gender: this.form.gender,
            birthCity: this.form.birthCity,
            birthDate: this.form.birthDate,
            age: this.form.age.toString(),
            marriage: this.form.marriage,
            children: this.form.children.toString(),
            custody: this.form.custody.toString(),
            address: this.form.address,
            homeStatus: this.form.homeStatus,
            mobile: this.form.mobile.toString(),
            phone: this.form.phone.toString(),
            latestDegree: this.form.latestDegree,
            education: JSON.stringify(this.form.education),
            experience: this.form.experience.toString(),
            jobs: JSON.stringify(this.form.jobs),
            salary: this.form.salary.toString(),
            field: this.form.field,
            notes: this.form.notes,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.vLoading = false;
            this.isBusy = false;
            if (res.status == 200) {
              if (this.form.status == "active") {
                this.$router.push("/hrm/activeForms");
              } else {
                this.$router.push("/hrm/deactiveForms");
              }
              this.toast("فرم با موفقیت ویرایش شد", "success");
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            this.vLoading = false;
            this.isBusy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
  },
  mounted() {
    this.showForm();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.app-body {
  overflow-x: unset !important;
}
</style>